import { useRecordContext } from 'react-admin'
export const ClubsLocation = () => {
	const record = useRecordContext()
	return <span>{record.City ? `${record.City}, ` : ''} {record.StateorProvince ? `${record.StateorProvince}` : ''} {record.PostalCode ? `${record.PostalCode}` : ''} {record.CountryISO2 && record.CountryISO2 !== 'ZZ' ? `${record.Countries.ISO3}` : ''}</span>
}
export default ClubsLocation